import Http from '@/utils/http'
const baseUrl = '/app/teacher'

/**
 *新增题目
 * @param params
 * 
*/

export const addQuestion = params => Http.post(`${baseUrl}/sz/team/exam/question`, params )

/**
 *修改题目
 * @param params
 * 
*/

export const editQuestion = params => Http.put(`${baseUrl}/sz/team/exam/question`, params )

/**
 *删除题目
 * 
*/

export const delQuestion = ids => Http.delete(`${baseUrl}/sz/team/exam/question/${ids}` )

/**
 *题目列表
 * @param params
 * 
*/

export const questionList = params => Http.get(`${baseUrl}/sz/team/exam/question`, { params } )

/**
 *题目详情
 * @param id
 * 
*/

export const questionInfo = id => Http.get(`${baseUrl}/sz/team/exam/question/${id}`)

/**
 *评测结果
 * @param params
 * 
*/

export const result = params => Http.get(`${baseUrl}/sz/team/exam/question/teamPostInfo`, { params } )

/**
 *重置问卷
 * @param classId
 * 
*/

export const resetList = classId => Http.post(`${baseUrl}/sz/team/exam/question/${classId}/reset`)

